function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { Children, cloneElement, isValidElement, useState } from 'react';
import cl from 'classnames';
import { isElementOfType, useCheckOverflow } from '@deephaven/react-hooks';
import { NON_BREAKING_SPACE } from '@deephaven/utils';
import { Text } from "./Text.js";
import ItemTooltip from "./ItemTooltip.js";
import stylesCommon from "../SpectrumComponent.module.css";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Item content. Text content will be wrapped in a Spectrum Text
 * component with ellipsis overflow handling. If text content overflows and
 * tooltipOptions are provided a tooltip will be displayed when hovering over
 * the item content.
 */
export function ItemContent(_ref) {
  var content = _ref.children,
    tooltipOptions = _ref.tooltipOptions;
  var _useCheckOverflow = useCheckOverflow(),
    checkOverflow = _useCheckOverflow.checkOverflow,
    isOverflowing = _useCheckOverflow.isOverflowing,
    resetIsOverflowing = _useCheckOverflow.resetIsOverflowing;
  var _useState = useState(content),
    _useState2 = _slicedToArray(_useState, 2),
    previousContent = _useState2[0],
    setPreviousContent = _useState2[1];

  // Reset `isOverflowing` if content changes. It will get re-calculated as
  // `Text` components render.
  if (previousContent !== content) {
    setPreviousContent(content);
    resetIsOverflowing();
  }
  if (/*#__PURE__*/isValidElement(content)) {
    return content;
  }

  /* eslint-disable no-param-reassign */
  if (content === '') {
    // Prevent the item height from collapsing when the content is empty
    content = NON_BREAKING_SPACE;
  } else if (typeof content === 'boolean') {
    // Boolean values need to be stringified to render
    content = String(content);
  } else if (Array.isArray(content)) {
    // For cases where there are multiple `Text` children, add a css class to
    // handle overflow. The primary use case for multiple text nodes is when a
    // description is provided for an item. e.g.
    // <Item textValue="Some Text">
    //   <SomeIcon />
    //   <Text>Some Label</Text>
    //   <Text slot="description">Some Description</Text>
    // </Item>
    content = Children.map(content, el => isElementOfType(el, Text) ? /*#__PURE__*/cloneElement(el, _objectSpread(_objectSpread({}, el.props), {}, {
      ref: checkOverflow,
      UNSAFE_className: cl(el.props.UNSAFE_className, stylesCommon.spectrumEllipsis)
    })) : el);
  }
  if (typeof content === 'string' || typeof content === 'number') {
    content = /*#__PURE__*/_jsx(Text, {
      ref: checkOverflow,
      UNSAFE_className: stylesCommon.spectrumEllipsis,
      children: content
    });
  }
  /* eslint-enable no-param-reassign */

  var tooltip = tooltipOptions == null || !isOverflowing ? null : /*#__PURE__*/_jsx(ItemTooltip, {
    options: tooltipOptions,
    children: content
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [content, tooltip]
  });
}
export default ItemContent;
//# sourceMappingURL=ItemContent.js.map